/**
 * @graph-stack web-design-system
 * @graph-domain UX
 * @graph-business チェックボックスコンポーネント。ネイティブ input[type=checkbox] にデザイントークンを適用したフォームプリミティブ
 * @graph-connects none
 */
import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../../lib/cn';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/** @graph-connects none */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="checkbox"
      className={cn(
        'w-4 h-4 shrink-0 rounded border border-[var(--color-border)] bg-[var(--color-bg-surface)] accent-[var(--color-accent-primary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-border-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-bg-base)] disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  ),
);

Checkbox.displayName = 'Checkbox';
